export default __webpack_public_path__ + "static/media/Art-Left.5970413e.png";